<template>
  <div class="renderer py-1 w-100">
    <ChannelItem 
      v-for="channel in channels" 
      :key="channel.id"
      :channel="channel"
    />
  </div>
</template>

<script>
import ChannelItem from "@/components/watchmen/channels/ChannelItem";

export default {
  name: "ChannelsTableRenderer",
  components: {
    ChannelItem,
  },
  computed: {
    channels: function () {
      return this.object.channels;
    },
  },
  props: ["object"],
  components: { ChannelItem },
};
</script>

<style lang="scss" scoped></style>
